var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogIn = function SvgLogIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0a1 1 0 0 1 0 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h2a1 1 0 0 1 0 2H5a5.007 5.007 0 0 1-5-5V5a5.007 5.007 0 0 1 5-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.725 4.987a1.002 1.002 0 0 1 .927 1.395q-.08.185-.224.325l-3.88 3.879a2 2 0 0 0-.325.445L23 11a1 1 0 0 1 0 2l-15.744.031q.123.21.29.383l3.88 3.879a1 1 0 1 1-1.414 1.414l-3.88-3.88a4 4 0 0 1 0-5.655l3.882-3.879a1 1 0 0 1 .71-.306"
  })));
};
export default SvgLogIn;